import React from 'react';
import PropTypes from 'prop-types';
import { TextFieldWithController } from '../TextField';
import { EmailFieldWithController } from '../EmailField';
import ValidationError from '../ValidationError';
import {
  getEmailValidation,
  getPasswordValidation,
  getRequiredValidation,
} from '../lib/validationRules';

const BasicSignupFields = ({
  firstNameLabel,
  lastNameLabel,
  emailAddressLabel,
  passwordLabel,
  requiredValidationMessage,
  emailValidationMessage,
  passwordTooShortMessage,
  formatEmailSuggestion,
  control,
  errors,
}) => (
  <>
    <div className="form-item">
      <TextFieldWithController
        name="firstName"
        control={control}
        rules={getRequiredValidation(requiredValidationMessage)}
        variant="filled"
        id="signup-first-name"
        label={firstNameLabel}
      />
      <ValidationError errors={errors} name="firstName" />
    </div>

    <div className="form-item">
      <TextFieldWithController
        name="lastName"
        control={control}
        rules={getRequiredValidation(requiredValidationMessage)}
        variant="filled"
        id="signup-last-name"
        label={lastNameLabel}
      />
      <ValidationError errors={errors} name="lastName" />
    </div>

    <div className="form-item">
      <EmailFieldWithController
        name="email"
        control={control}
        rules={
          getEmailValidation(
            emailValidationMessage,
            requiredValidationMessage,
          )
        }
        variant="filled"
        id="signup-email"
        label={emailAddressLabel}
        formatSuggestion={formatEmailSuggestion}
        useStringOnClick
      />
      <ValidationError errors={errors} name="email" />
    </div>

    <div className="form-item">
      <TextFieldWithController
        name="password"
        control={control}
        rules={
          getPasswordValidation(
            passwordTooShortMessage,
            requiredValidationMessage,
          )
        }
        variant="filled"
        id="signup-password"
        type="password"
        label={passwordLabel}
      />
      <ValidationError errors={errors} name="password" />
    </div>
  </>
);

BasicSignupFields.propTypes = {
  firstNameLabel: PropTypes.string.isRequired,
  lastNameLabel: PropTypes.string.isRequired,
  emailAddressLabel: PropTypes.string.isRequired,
  passwordLabel: PropTypes.string.isRequired,
  requiredValidationMessage: PropTypes.string.isRequired,
  emailValidationMessage: PropTypes.string.isRequired,
  passwordTooShortMessage: PropTypes.string.isRequired,
  formatEmailSuggestion: PropTypes.func.isRequired,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
};

export default BasicSignupFields;
